import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const getCouponAuthHeaders = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  if (!token || token === "null" || token === "undefined") {
    const error = new Error("Please login again to manage coupons.");
    error.statusCode = 401;
    throw error;
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export default getCouponAuthHeaders;
